var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5167 16.9632H17.25M15.3833 15.1765V18.75M10.05 5.25C10.05 6.51368 10.5557 7.7256 11.4559 8.61916C12.3561 9.51271 13.577 10.0147 14.85 10.0147C13.577 10.0147 12.3561 10.5167 11.4559 11.4103C10.5557 12.3038 10.05 13.5157 10.05 14.7794C10.05 13.5157 9.54429 12.3038 8.64411 11.4103C7.74394 10.5167 6.52304 10.0147 5.25 10.0147C6.52304 10.0147 7.74394 9.51271 8.64411 8.61916C9.54429 7.7256 10.05 6.51368 10.05 5.25Z",
    stroke: "#383ECD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadingIcon);
export default __webpack_public_path__ + "static/media/leading-icon.54319d63981e1084cf4b39b2fbbaeb46.svg";
export { ForwardRef as ReactComponent };